module.exports = __webpack_public_path__ + "static/media/whatsapp.2be3fec3.png";